import { createAction } from '@reduxjs/toolkit'

const UPDATE_USER_ID = 'UPDATE_USER_ID'
const UPDATE_TOKEN = 'UPDATE_TOKEN'

export const updateUserId = createAction<string>(UPDATE_USER_ID)
export const updateToken = createAction<string>(UPDATE_TOKEN)
